import { AsyncRestClient } from "@/infrastructure/backend/async/AsyncRestClient";
import { Navigate } from "@/infrastructure/backend/async/Navigate";
import { UserProfile } from "@/infrastructure/backend/userProfile";
import { MapGebietRow } from "../geo-modules/geo-json-types";

// **********************************************************
export async function loadGeoRevier(revierNumber: any , produkt: string | undefined , typ: string | undefined ) : Promise<MapGebietRow[] | undefined> {

    if (revierNumber &&  typeof(revierNumber) !== typeof("string") ) {
        revierNumber = revierNumber.key
    }

    if (revierNumber &&  typeof(revierNumber) === typeof("string") ) {
        if ( ! revierNumber || revierNumber?.length < 1 || !typ || typ.length < 1) return
    }

    if ( ! produkt) produkt = "";

    if (  typ && (typ === "Kanton" || typ === "jagdrevier") ) produkt = "";


    // if (Navigate.IsLocked()) {
    //     return undefined
    // }

     const language = (await UserProfile.GetClientSettingsAsync()).language

    const client = AsyncRestClient.Create(true);
    if (client.isFailure) throw new Error("Error.syncFishbook");
    const result = await client
        .getValue()
        .exchangeForComponents<string, string>(process.env.VUE_APP_API + "api/geo/geoRevier", JSON.stringify({RevierNumber: revierNumber, Produkt: produkt, Typ: typ, Language: language}));  

    if (result.isFailure) {                       
        return undefined
    }       
    
    let apiResult: any = undefined

    try {
       apiResult = result.getValue()
    } catch(e) {
        return undefined
    }

    if ( !apiResult || apiResult.length === 0 || !apiResult[0].mapGebietGeoJson) {
        return undefined
    }

    try {
        return apiResult as MapGebietRow[]
    } catch (error) {
        return undefined;
    }
}